import { render, staticRenderFns } from "./ColumnItemIcon.vue?vue&type=template&id=518f5522&scoped=true&"
import script from "./ColumnItemIcon.vue?vue&type=script&lang=ts&"
export * from "./ColumnItemIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnItemIcon.vue?vue&type=style&index=0&id=518f5522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f5522",
  null
  
)

export default component.exports